import * as Sentry from "@sentry/react";

const initSentry = () => {
    Sentry.init({
        dsn: "https://eae7932e8b07c24f16416d32e9004502@o1398692.ingest.us.sentry.io/4507854183006208",
        environment: process.env.REACT_MACHINE_ENV,
        tracesSampleRate: 1.0,
        replaysSessionSampleRate: 0.1,
        replaysOnErrorSampleRate: 1.0,
        ignoreErrors: [
            `'microphone' (value of 'name' member of PermissionDescriptor) is not a valid value for enumeration PermissionName.`,
            `'camera' (value of 'name' member of PermissionDescriptor) is not a valid value for enumeration PermissionName.`,
            "There is already an encoder stored which handles exactly the same mime types.",
        ],
    });
};

export default initSentry;
